module.exports = __webpack_public_path__ + "img/balance.a193d5ef.png";